import './SelectField.css';
export default {
    "root": "SelectField_root__1dsvm",
    "hasPlaceholder": "SelectField_hasPlaceholder__1dsvm",
    "hasPrefix": "SelectField_hasPrefix__1dsvm",
    "chevronButton": "SelectField_chevronButton__1dsvm"
};
